<template>
    <v-btn :height="height" :width="width" rounded depressed v-bind="$attrs" v-on="$listeners">
        <slot></slot>
    </v-btn>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        height: {
            type: [Number, String],
            default: 55
        },
        width: {
            type: [Number, String],
            default: 190
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .v-btn__content {
    text-transform: capitalize;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    letter-spacing: 0.14px;
}
</style>
